module.exports = __webpack_public_path__ + "img/riviera-cenote.faed4990.jpg";